var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login"},[_c('van-popup',{attrs:{"close-on-click-overlay":false},model:{value:(_vm.showLogin),callback:function ($$v) {_vm.showLogin=$$v},expression:"showLogin"}},[_c('login-form',{attrs:{"state":_vm.state,"title":"绑定手机","tips":"您需要绑定手机后使用"},on:{"success":_vm.onSuccess,"error":_vm.onError}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }